import { render, staticRenderFns } from "./Container.vue?vue&type=template&id=2ca673e5&scoped=true&"
import script from "./Container.vue?vue&type=script&lang=ts&"
export * from "./Container.vue?vue&type=script&lang=ts&"
import style0 from "./Container.vue?vue&type=style&index=0&id=2ca673e5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca673e5",
  null
  
)

export default component.exports